import api from './api';

export interface ProjetoDefinicao {
    id: string;
    index: number;
    codigo: string;
    numero: string;
    nome: string;
    previsao: string;
    forecastAno: boolean;
    contagemNaoPrevisto: boolean;
    vrp: boolean;
    rpp: boolean;

    previsaoCodigo: number;
    cicloOrcamentarioId: string;
    statusProjetoNome: string;
    dataConclusao: string;
}

export const getAllProjetoDefinicao = (ano: number) => api.get<ProjetoDefinicao[]>(`definicaoProjeto/${ano}`);
export const updateCicloOrcamentarioProjeto = (values: ProjetoDefinicao) => api.put<ProjetoDefinicao>(`definicaoProjeto/updateDefinicaoProjeto/${values.id}`, values);
export const updateconcluirCicloOrcamentario = (id: string) => api.put<ProjetoDefinicao>(`definicaoProjeto/concluirCicloOrcamentario/${id}`);

